define('AutocompleteComponent',[], function () {
  /**
   * @abstract
   * @class     
   * @param {HTMLElement} context Element context
   * @param {Observable} observable Observable instance
   * @param {SuggestionsEngine} engine Suggestions Engine
   * @param {SuggestionsComponent} suggestionsComponent Suggestions Component
   */
  function AutocompleteComponent(context, observable, engine, suggestionsComponent) {
    /**
     * @property {Observable} _observable Observable         
     */
    this._observable = observable;

    /**
     * @property {HTMLInputElement} _searchField Search field
     */
    this._searchField = this._observable.field;

    /**
     * @property {SuggestionsEngine} _engine Suggestions engine
     */
    this._engine = engine;

    /**
     * @property {SuggestionsComponent} _suggestionsComponent Suggestions component
     */
    this._suggestionsComponent = suggestionsComponent;

    /**
     * @property {HTMLElement} _context DOM Context
     */
    this._context = context;

    /**
     * @property {*[]}
     */
    this.suggestions = [];

    /**
     * @property {*} value Returns the selected suggestion of the suggestions conponent
     */
    Object.defineProperty(this, "value", {
      get: (function () {
        return this._suggestionsComponent ? this._suggestionsComponent.getSelectedSuggestion() : null;
      }).bind(this)
    });

    this._observable.add(this); // Add observer to observable        
    this._initEvents(); // Init DOM events
  }

  AutocompleteComponent.prototype._clickHandler = function (event) {
    if (event.target === this._context || this._context.contains(event.target)) return;
    if (this._suggestionsComponent) {
      this._suggestionsComponent.close();
    }
  };

  /**
   * Initializes the DOM events
   * @method     
   */
  AutocompleteComponent.prototype._initEvents = function () {
    document.body.addEventListener("click", this._clickHandler.bind(this));
    document.body.addEventListener("touchstart", this._clickHandler.bind(this), { passive: true });
  };

  /**
   * Updates the Autocomplete Suggestions
   * @method     
   * @param {Function} callback Callback
   */
  AutocompleteComponent.prototype.update = function (callback) {
    if (this._searchField.value && this._suggestionsComponent.getSelectedSuggestion() === null) {
      this._engine.getSuggestions(this._searchField, (function (suggestions) {
        this.suggestions = suggestions;
        this.displaySuggestions();
        if (callback instanceof Function) {
          callback();
        }
      }).bind(this));
    } else if (!this._searchField.value) {
      this._suggestionsComponent.close();
    }
  };

  /**
   * Displays the suggestions
   * @method
   */
  AutocompleteComponent.prototype.displaySuggestions = function () {
    this._suggestionsComponent.close();
    this._suggestionsComponent.clear();
    if (!this.suggestions.length) {
      return;
    }
    var highlight = this.includeHighlightInSuggestion ? new RegExp(this._searchField.value.trim(), "i") : '';
    for (var index = 0; index < this.suggestions.length; index++) {
      this._suggestionsComponent.add(this.suggestions[index], highlight);
    }
    if (!this._suggestionsComponent.htmlElement.parentElement) {
      this._context.appendChild(this._suggestionsComponent.htmlElement);
    }
    this._suggestionsComponent.open();
  };

  /**
   * Selects a suggestion
   * @method
   * @param {Number} index Suggestion's index
   */
  AutocompleteComponent.prototype.selectSuggestion = function (index) {
    this.hideSuggestions();
    this._searchField.value = this.suggestions[index].name;
  };


  AutocompleteComponent.prototype.hideSuggestions = function () {
    if (this._suggestionsComponent) {
      this._suggestionsComponent.close();
    }
  };

  return AutocompleteComponent;
});

/**
 * Made with ♥ by NewHomeSource's team
 * Copyright (c) 2019-present, BuilderHomeSite Inc. All rights reserved.
 */;
